import { FunctionComponent, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import './ViewAds.scss';
import ButtonField from '../../Components/Button/ButtonField';
import { useNavigate, useParams } from 'react-router-dom';
import { ILocationList, MastersProps } from '../Location/ILocation';
import { getOneLocation } from '../../Redux/Slicers/Location/GetOneLocationSlicer copy';
import { getAds } from '../../Redux/Slicers/Location/GetAdsSlicer';

interface AdsData {
  location_id: any;
  ads_type: {
    title: string;
    description: string;
    image: string;
    link: string;
  };
}

const ViewAds: FunctionComponent<MastersProps> = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const { id }: any = useParams();

  useEffect(() => {
    dispatch(getAds(id));
  }, []);
  const nav = useNavigate();
  const { data: GetAds } = useAppSelector((state) => state?.GetAds);

  const locationData = GetAds?.response?.data;

  return (
    <>
      {locationData?.length > 0 ? (
        <div className="Location_view_main_container">
          <div
            className="Location_view_container "
            style={{ flexDirection: 'column' }}>
            {locationData?.map((e: any, index: any) => (
              <div className="Location_view_schedule_card">
                <p className="view_card_title">Ads History : {index + 1}</p>
                <div className="view_schedule_contant">
                  <table
                    className="table"
                    key={e.location_id}>
                    <tbody>
                      <tr>
                        <th>Date & Time</th>
                        <td>
                          :&nbsp;&nbsp;&nbsp;&nbsp;
                          {new Date(e?.created_at).toLocaleDateString(
                            'en-GB'
                          )}{' '}
                          ,&nbsp;
                          {new Date(e?.created_at).toLocaleTimeString('en-GB', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false,
                          })}
                        </td>
                      </tr>
                      <tr>
                        <th>Location Name</th>
                        <td>
                          :&nbsp;&nbsp;&nbsp;&nbsp;
                          {e?.location_id.location_name}
                        </td>
                      </tr>
                      <tr>
                        <th>Ads Title</th>
                        <td>:&nbsp;&nbsp;&nbsp;&nbsp;{e?.ads_type?.title}</td>
                      </tr>
                      <tr>
                        <th>Ads Description</th>
                        <td>
                          :&nbsp;&nbsp;&nbsp;&nbsp;{e?.ads_type?.description}
                        </td>
                      </tr>
                      <tr>
                        <th>Ads Link</th>
                        <td>
                          :&nbsp;&nbsp;&nbsp;&nbsp;
                          {e?.ads_type?.link && (
                            <a
                              href={e.ads_type.link}
                              target="_blank"
                              rel="noopener noreferrer">
                              {e.ads_type.link}
                            </a>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th
                          style={{
                            display: 'flex',
                            width: '10px',
                            maxHeight: '10px',
                          }}>
                          Ads Image
                        </th>
                        <td>
                          : &nbsp;&nbsp;&nbsp;&nbsp;
                          {e?.ads_type?.image?.length > 0 && (
                            <>
                              {e.ads_type.image.map((f: any, index: number) => (
                                <img
                                  key={index}
                                  src={`${process.env.REACT_APP_API_URL}/${f}`}
                                  alt={'Img not found'}
                                  style={{
                                    maxWidth: '40px', // Thumbnail size
                                    height: 'auto',
                                    maxHeight: '200px',
                                    marginRight: '10px',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease-in-out',
                                  }}
                                  onClick={() =>
                                    setSelectedImage(
                                      `${process.env.REACT_APP_API_URL}/${f}`
                                    )
                                  }
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(2)')
                                  } // Zoom effect
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(1)')
                                  } // Reset on hover out
                                />
                              ))}
                            </>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
          {selectedImage && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => setSelectedImage(null)} // Close modal when clicking outside
            >
              <img
                src={selectedImage}
                alt="Full Image"
                style={{
                  height: '400px',
                  borderRadius: '10px',
                  boxShadow: '0px 0px 15px white',
                }}
              />
            </div>
          )}
        </div>
      ) : (
        <div style={{ textAlign: 'center', fontSize: '20px' }}>
          History data not found
        </div>
      )}
    </>
  );
};

export default ViewAds;
